import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cards from '../../../Components/Cards/Cards';
import Stats from '../../../Components/Stats/Stats';
import { RecordingSource } from '../../../Utils/Constants';
import './RecordingsStats.css';
import { humanizeNumber } from '../../../Utils/NumberUtils';
import { SelectedAndTotal } from '../../../Components/SelectedAndTotal/SelectedAndTotal';
class RecordingsStats extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    totalRecordings: PropTypes.number,
    totalStandaloneViews: PropTypes.number,
    totalG2SViews: PropTypes.number,
    totalG2SShares: PropTypes.number,
    selectedRecordingsCount: PropTypes.number,
    selectedRecording: PropTypes.object
  };
  render() {
    let {
      totalRecordings: recordingsCount = 0,
      totalStandaloneViews: standaloneCount = 0,
      totalG2SViews: g2sViewCount = 0,
      totalG2SShares: g2sShareCount = 0,
      isBig,
      selectedRecording,
      selectedRecordingsCount
    } = this.props;
    const { t } = this.context;

    let recordingsSubtext = t('header.cardTypes.totalRecordings');
    if (selectedRecordingsCount !== recordingsCount) {
      recordingsCount = selectedRecordingsCount;
      recordingsSubtext = t('recordings.selectedRecordingsTitle');
    }

    if (selectedRecording && !isBig) {
      const { viewCount, shareCount, source } = selectedRecording;
      recordingsCount = 1;
      standaloneCount = RecordingSource.G2W === source ? viewCount : 0;
      g2sViewCount = RecordingSource.G2S === source ? viewCount : 0;
      g2sShareCount = RecordingSource.G2S === source ? shareCount : 0;
      recordingsSubtext = t('recordings.selectedRecordingsTitle');
    }

    const cardArray = [
      {
        uniqueId: 'totalRecordings',
        subText: recordingsSubtext,
        title: recordingsCount,
        moreInfoTooltip: t('header.cardTypes.totalRecordingsTooltip'),
        cardFooterComponent: (
          <div className="statSelection">
            <SelectedAndTotal
              totalRecords={this.props.totalRecordings}
              selectedRecords={selectedRecordingsCount}
              type={'recordings'}
            />
          </div>
        )
      },
      {
        uniqueId: 'totalStandaloneViews',
        subText: t('header.cardTypes.totalStandaloneViews'),
        title: humanizeNumber(standaloneCount),
        moreInfoTooltip: t('header.cardTypes.totalStandaloneViewsTooltip')
      },
      {
        uniqueId: 'totalG2SViews',
        subText: t('header.cardTypes.totalGoToStageViewsNew'),
        title: humanizeNumber(g2sViewCount),
        moreInfoTooltip: t('header.cardTypes.totalG2SViewsTooltip')
      },
      {
        uniqueId: 'totalG2SShares',
        subText: t('header.cardTypes.totalGoToStageSharesNew'),
        title: humanizeNumber(g2sShareCount),
        moreInfoTooltip: t('header.cardTypes.totalG2SSharesTooltip')
      }
    ];
    return isBig ? <Cards contents={cardArray} /> : <Stats contents={cardArray} />;
  }
}
export default RecordingsStats;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Recordings/Stats/RecordingsStats.js